export const environment = {
    production: true,
    baseUrl: 'https://capitaljps-002-site1.stempurl.com',
    rootUrl: 'https://your-league.com/',
};
